import React, { useState } from 'react';
import { Heart, User } from 'lucide-react';

const ComplimentGame = ({ config, onEnd, currentTheme }) => {
    const [residentName, setResidentName] = useState("");
    const [givenCompliments, setGivenCompliments] = useState([]);

    const complimentsPool = config.compliments || ["Gentil(le)", "Souriant(e)", "Élégant(e)", "Drôle", "Généreux(se)"];

    const handleAddCompliment = (comp) => {
        if (!residentName) return alert("Entrez d'abord un prénom !");
        if (!givenCompliments.includes(comp)) {
            setGivenCompliments([...givenCompliments, comp]);
        }
    };

    const handleReset = () => {
        setResidentName("");
        setGivenCompliments([]);
    };

    return (
        <div className="compliment-container">
            <h2 className="compliment-main-title">Le Mur des Compliments</h2>

            <div className="resident-profile-section">
                <div className="avatar-circle">
                    <User size={80} />
                </div>
                <input
                    type="text"
                    placeholder="Prénom du résident..."
                    value={residentName}
                    onChange={(e) => setResidentName(e.target.value)}
                    className="resident-name-input"
                />
            </div>

            <div className="compliment-wall-area">
                {givenCompliments.length === 0 && <span className="wall-placeholder">Glissez ou cliquez sur les qualités ci-dessous pour {residentName || "..."}</span>}

                {givenCompliments.map((comp, idx) => (
                    <div key={idx} className="active-compliment-tag">
                        <Heart size={24} fill="currentColor" /> {comp}
                    </div>
                ))}
            </div>

            <div className="compliment-pool">
                {complimentsPool.map((comp, idx) => (
                    <button
                        key={idx}
                        onClick={() => handleAddCompliment(comp)}
                        disabled={!residentName}
                        className={`pool-tag-btn ${!residentName ? 'disabled' : ''}`}
                    >
                        {comp}
                    </button>
                ))}
            </div>

            <div className="compliment-footer">
                <button onClick={handleReset} className="btn-new-resident">
                    Nouveau Résident
                </button>
            </div>
        </div>
    );
};

export default ComplimentGame;